/**
 * What a feature keeps in this browser for one account and drops when that account signs out
 * here, such as which PC this browser is on (W-06). The session runs them; it doesn't know
 * what they clear.
 */
type SignOutCleanup = (userId: string) => void;

const cleanups = new Set<SignOutCleanup>();

/** Registers a cleanup once, at module load; it runs at every sign-out from this browser. */
export function onSignOut(cleanup: SignOutCleanup): void {
  cleanups.add(cleanup);
}

/** Runs every cleanup for the account that signs out; one that throws doesn't stop the others. */
export function runSignOutCleanups(userId: string): void {
  for (const cleanup of cleanups) {
    try {
      cleanup(userId);
    } catch {
      // Browser storage is a convenience: a failed removal leaves only a stale hint.
    }
  }
}
